import { GRUNDWORTSCHATZ_HESSEN_SYLLABLES } from "./blitzlesen-grundwortschatz-silben";

const V1_SILBENTRENNUNG_WOERTER = [
  "Ameise",
  "Auge",
  "Biene",
  "Blume",
  "Blüte",
  "böse",
  "Ende",
  "Ente",
  "Eule",
  "Feuer",
  "Freude",
  "Gemüse",
  "Hase",
  "heute",
  "Hose",
  "Junge",
  "Küche",
  "leise",
  "Leute",
  "Name",
  "Nase",
  "Ochse",
  "Pflaume",
  "Raupe",
  "Riese",
  "Sache",
  "Schere",
  "Schlange",
  "Seife",
  "Seite",
  "Tante",
  "Tasche",
  "Wiese",
  "Woche",
  "bauen",
  "biegen",
  "bleiben",
  "brauchen",
  "bringen",
  "dachten",
  "fangen",
  "finden",
  "fliegen",
  "fragen",
  "freuen",
  "Frieden",
  "frieren",
  "geben",
  "halten",
  "helfen",
  "holen",
  "hören",
  "impfen",
  "kaufen",
  "kleben",
  "kochen",
  "kriechen",
  "kriegen",
  "Kuchen",
  "lachen",
  "laufen",
  "leben",
  "legen",
  "lesen",
  "leuchten",
  "liegen",
  "machen",
  "malen",
  "oben",
  "pflanzen",
  "pflegen",
  "rechnen",
  "reden",
  "Regen",
  "reisen",
  "riechen",
  "rufen",
  "sagen",
  "schauen",
  "scheinen",
  "schieben",
  "schimpfen",
  "schlafen",
  "schlagen",
  "schneiden",
  "schreiben",
  "schreien",
  "schweigen",
  "sieben",
  "singen",
  "suchen",
  "tragen",
  "üben",
  "unten",
  "waschen",
  "wünschen",
  "zeigen",
  "zwischen",
  "Ampel",
  "Apfel",
  "Bügel",
  "Flügel",
  "Gabel",
  "Insel",
  "Nebel",
  "Nabel",
  "Nudel",
  "Pinsel",
  "Schnabel",
  "Tafel",
  "Teufel",
  "Windel",
  "Zwiebel",
  "Bruder",
  "erster",
  "euer",
  "Fenster",
  "Finger",
  "Hunger",
  "keiner",
  "Kleber",
  "leider",
  "Leiter",
  "Meter",
  "Pflaster",
  "Schwester",
  "selber",
  "Tochter",
  "anders",
  "Eltern",
  "flüstern",
  "gestern",
  "hundert",
  "Ostern",
  "Papier",
  "antworten",
  "Birne",
  "Erde",
  "gerne",
  "Gurke",
  "Kirche",
  "Kirsche",
  "Körper",
  "lernen",
  "merken",
  "morgen",
  "turnen",
  "Würfel",
  "Wurzel",
  "arbeiten",
  "Farbe",
  "Marke",
  "Nachbar",
  "sogar",
  "warten",
  "dürfen",
  "werden",
  "warum",
  "alle",
  "hatte",
  "immer",
  "können",
  "müssen",
  "sollen",
  "wollen",
  "ohne",
  "aber",
  "hinter",
  "oder",
  "über",
  "unter",
  "weiter",
  "wieder",
  "also",
  "eure",
  "etwas",
  "gegen",
  "habe",
  "haben",
  "jede",
  "mögen",
  "waren",
  "welche",
  "sparen",
  "Spiegel",
  "spielen",
  "sprechen",
  "springen",
  "streichen",
  "streiten",
  "Stunde",
  "Spaziergang",
  "Spinne",
  "stehen",
  "stellen",
  "Stimme",
  "Straße",
  "danken",
  "denken",
  "dunkel",
  "Onkel",
  "schenken",
  "trinken",
  "bequem",
  "Quadrat",
  "quaken",
  "Qualle",
  "Quelle",
  "quietschen",
  "Affe",
  "backen",
  "besser",
  "bitten",
  "blicken",
  "brennen",
  "Brille",
  "Brücke",
  "Butter",
  "Decke",
  "doppelt",
  "dreckig",
  "drucken",
  "drücken",
  "flüssig",
  "fressen",
  "Füller",
  "gucken",
  "Hessen",
  "Himmel",
  "Hitze",
  "hoffen",
  "Jacke",
  "Katze",
  "kennen",
  "Klasse",
  "klettern",
  "kommen",
  "kratzen",
  "lassen",
  "lecker",
  "Löffel",
  "messen",
  "Messer",
  "Mitte",
  "Mutter",
  "Mütze",
  "Nummer",
  "offen",
  "packen",
  "passen",
  "pflücken",
  "Puppe",
  "putzen",
  "rennen",
  "rollen",
  "Rücken",
  "sammeln",
  "schaffen",
  "Schlüssel",
  "schmecken",
  "schütteln",
  "schwimmen",
  "schwitzen",
  "Sessel",
  "setzen",
  "sitzen",
  "Sommer",
  "Sonne",
  "Tanne",
  "Tasse",
  "Teller",
  "treffen",
  "trocken",
  "Wasser",
  "witzig",
  "Zimmer",
  "Zucker",
  "allein",
  "bekommen",
  "bisschen",
  "Donnerstag",
  "entdecken",
  "entwickeln",
  "erinnern",
  "erschrecken",
  "Fußball",
  "hallo",
  "herstellen",
  "hoffentlich",
  "innerhalb",
  "interessant",
  "kaputt",
  "letzte",
  "Mittag",
  "Mittwoch",
  "passieren",
  "plötzlich",
  "Programm",
  "Pullover",
  "Pommes",
  "Sonntag",
  "überall",
  "vergessen",
  "verletzen",
  "verstecken",
  "vielleicht",
  "zuletzt",
  "zurück",
  "zusammen",
  "blühen",
  "drehen",
  "gehen",
  "Reihe",
  "Ruhe",
  "sehen",
  "ziehen",
  "bohren",
  "fahren",
  "fehlen",
  "Fehler",
  "fühlen",
  "Höhle",
  "Lehrer",
  "nehmen",
  "rühren",
  "wohnen",
  "ähnlich",
  "bezahlen",
  "erzählen",
  "Fahrrad",
  "Frühling",
  "Frühstück",
  "Gefahr",
  "ungefähr",
  "Verkehr",
  "während",
  "Weihnachten",
  "Beere",
  "Idee",
  "Abend",
  "genug",
  "genügende",
  "gesund",
  "Gründe",
  "Münder",
  "tausend",
  "Urlaub",
  "Züge",
  "Flugzeug",
  "Montag",
  "Dienstag",
  "Freitag",
  "Samstag",
  "deshalb",
  "endlich",
  "Ergebnis",
  "irgend",
  "jemand",
  "Jugend",
  "Mädchen",
  "niemand",
  "Ordnung",
  "unterwegs",
  "aufräumen",
  "aufwachen",
  "Gesicht",
  "deutlich",
  "eigentlich",
  "nämlich",
  "natürlich",
  "schließlich",
  "fertig",
  "fleißig",
  "Käfig",
  "König",
  "mutig",
  "richtig",
  "riesig",
  "schwierig",
  "vorsichtig",
  "bevor",
  "davon",
  "November",
  "Silvester",
  "Vase",
  "Vater",
  "verbieten",
  "Verein",
  "verlieren",
  "Versuch",
  "verwandt",
  "viele",
  "Virus",
  "Vogel",
  "vorne",
  "vorwärts",
  "Vulkan",
  "wachsen",
  "wechseln",
  "boxen",
  "Hexe",
  "Lexikon",
  "Taxi",
  "Baby",
  "Handy",
  "Pony",
  "Teddy",
  "Comic",
  "Computer",
  "Chance",
  "ärgern",
  "erklären",
  "hängen",
  "Käfer",
  "Käse",
  "nächste",
  "Träne",
  "Auto",
  "Euro",
  "Europa",
  "Ferien",
  "Internet",
  "Kalender",
  "Lineal",
  "Linie",
  "Maschine",
  "Medien",
  "Minute",
  "Monat",
  "Musik",
  "Paket",
  "Pizza",
  "Radio",
  "Sekunde",
  "Telefon",
  "Temperatur",
  "Theater",
  "Thema",
  "trainieren",
  "Januar",
  "Februar",
  "April",
  "Juni",
  "Juli",
  "August",
  "September",
  "Oktober",
  "Dezember",
  "Igel",
  "Liter",
  "Tiger",
  "bereits",
  "Geburtstag",
  "außen",
  "beißen",
  "draußen",
  "fließen",
  "gießen",
  "grüßen",
  "ließen",
  "reißen",
  "schließen",
  "Soße",
  "Entfernung",
  "Heizung",
  "Zeitung",
  "Zeugnis"
] as const;

export interface SilbentrennungWordSource { id: string; surface: string; lemma: string; syllables: string[]; }

/** Die vollständige, aus V1 übernommene Wortquelle für Lesesilbentrennung. */
export const SILBENTRENNUNG_V1_WORDS: SilbentrennungWordSource[] = V1_SILBENTRENNUNG_WOERTER.map((surface, index) => {
  const lemma = surface.toLocaleLowerCase("de-DE");
  const syllables = GRUNDWORTSCHATZ_HESSEN_SYLLABLES[lemma];
  if (!syllables) throw new Error("Für das Silbentrennungswort fehlt eine kuratierte Silbenfolge: " + surface);
  return { id: "silbe-" + (index + 1), surface, lemma, syllables: [...syllables] };
});
